import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=2d8c8ec0&scoped=true"
import script from "./authorization.vue?vue&type=script&lang=ts"
export * from "./authorization.vue?vue&type=script&lang=ts"
import style0 from "./authorization.vue?vue&type=style&index=0&id=2d8c8ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c8ec0",
  null
  
)

export default component.exports